/* eslint-disable */
import {Route} from 'react-router'
import Layout from './components/Layout'
import './style.css'
import {Provider} from 'react-redux'
import {ConnectedRouter} from 'connected-react-router'
import {createBrowserHistory} from 'history'
import configureStore from './store/configureStore'
import {Switch} from 'react-router-dom'
import * as _ from 'lodash'
import React from 'react'

// Create browser history to use in the Redux store
const browserHistory = createBrowserHistory({basename: _.first(document.getElementsByTagName('base')).getAttribute('href')})

// Get the application-wide store instance, prepopulating with state from the server where available.
const store = configureStore(browserHistory)

const App = (): any =>
  <Provider store={store}>
    <span style={{fontFamily: 'Inter'}}>
      <ConnectedRouter history={browserHistory}>
        <Switch>
          <Route path='/:userId/:timestamp/:timestampDemo?' component={Layout}/>
        </Switch>
      </ConnectedRouter>
    </span>
  </Provider>

export default App